import React from "react";
import './Blogs.css';
import { Card, Col, Container, Row, Button } from "react-bootstrap";

const Blogs = () => {
  return (
    <div style={{margin: "100px 0"}}>
      <Container>
      <h1 style={{ fontWeight: '700', color: '#2c3e50', textAlign: 'center' }}>My Blogs Coming Soon...</h1>
      </Container>
    </div>
  );
};

export default Blogs;
